import {
  ControlledCheckbox,
  ControlledInput,
} from "components/Card/ControlledInput";
import FutureMedicalCard from "components/Card/FutureMedicalCard";
import { TextInput } from "components/inputs";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import type {
  AmendedReviewScreeningType,
  CostProjectionDataType,
  MSADataType,
} from "types/DataTypes";

type Props = {
  service?: MSADataType | CostProjectionDataType | AmendedReviewScreeningType;
  onSave: (field: string | null, value: unknown) => void;
  className?: string;
};

type ProfessionalAdminFormValues = {
  is_professionally_admined: boolean;
  professional_admin_company_name: string | null;
  professional_admin_company_ein: string | null;
};

const FutureMedicalProfessionalAdminCompany = ({
  service,
  onSave,
  className = "",
}: Props) => {
  const { control, reset } = useForm<ProfessionalAdminFormValues>({
    defaultValues: {
      is_professionally_admined: false,
      professional_admin_company_name: null,
      professional_admin_company_ein: null,
    },
  });

  useEffect(() => {
    if (service) {
      reset(
        {
          is_professionally_admined: service.is_professionally_admined || false,
          professional_admin_company_name:
            service.professional_admin_company_name || null,
          professional_admin_company_ein:
            service.professional_admin_company_ein || null,
        },
        { keepDirtyValues: true },
      );
    }
  }, [service, reset]);

  const handleSave = useCallback(
    (field: string) => async (value: unknown) => {
      await onSave(field, value);
    },
    [onSave],
  );

  return (
    <div className={`${className}`}>
      <FutureMedicalCard cardNumber={2} heading="Professional Admin Company">
        <ControlledCheckbox
          control={control}
          name="is_professionally_admined"
          label="Is Professionally Admin'd"
          errors={{}}
          onSave={handleSave("is_professionally_admined")}
        />
        <ControlledInput
          control={control}
          name="professional_admin_company_name"
          label="Prof Admin Company Name"
          errors={{}}
          onSave={handleSave("professional_admin_company_name")}
          componentType={TextInput}
          maxLength={100}
        />
        <ControlledInput
          control={control}
          name="professional_admin_company_ein"
          label="Prof Admin EIN"
          errors={{}}
          onSave={handleSave("professional_admin_company_ein")}
          componentType={TextInput}
          mask="none"
          maxLength={9}
        />
      </FutureMedicalCard>
    </div>
  );
};

export default FutureMedicalProfessionalAdminCompany;
